const createHtmlRenderState = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
export {
  createHtmlRenderState
};
//# sourceMappingURL=create-render-state.js.map
